module.exports = __webpack_public_path__ + "static/media/workIntro.dc058f92.mp4";